<template>
  <div class="section-account">
    <Banner
      :title="'ACCOUNT'"
      :class-banner="'common-banner'"
    />
    <TabsSwift
      :class-container="'section-account__tabs'"
      :tabs="tabs"
      :custom-class-title-item="'account-tab-title-item'"
    />
  </div>
</template>

<script>
import Banner from '@/components/common/banner';
import TabsSwift from '@/components/common/tabs/tabs-swift';
import TabNotifications from './tab-notifications';
import TabOverview from './tab-overview';
import TabQRCodes from './tab-qrcodes';
import TabSettings from './settings/tab-settings';

export default {
  components: {
    Banner,
    TabsSwift
  },
  data() {
    return {
      tabs: [
        {
          title: 'Overview',
          isShow: true,
          isActive: true,
          component: TabOverview,
          srcIconTab: 'overview-icon.png',
          isTabTitleCustom: true
        },
        {
          title: 'QR Codes',
          isShow: true,
          isActive: false,
          component: TabQRCodes,
          srcIconTab: 'qrcode-icon.png',
          isTabTitleCustom: true
        },
        {
          title: 'Settings',
          isShow: true,
          isActive: false,
          component: TabSettings,
          srcIconTab: 'settings-icon.png',
          isTabTitleCustom: true
        },
        {
          title: 'Notifications',
          isShow: true,
          isActive: false,
          component: TabNotifications,
          srcIconTab: 'notifications-icon.png',
          isTabTitleCustom: true
        }
      ]
    }
  },
  methods: {}
};
</script>
